import statusConst from '@/consts/status.const.js';
import comparableSubTabConst from '@/consts/comparableSubTab.const.js';
import comparableSetConst from '@/consts/comparableSet.const.js';

export default {
  getCommonAttributesToStore() {
    return {
      pageSize: 50,
      basket: null,
      comparables: null,
      comparablesFromCallWithoutSummation: null,
      filteredComparables: {
        [comparableSetConst.ALL]: [],
        [comparableSetConst.SELECTED]: [],
        [comparableSetConst.NO_SELECTED]: [],
      },
      selectedComparableSet: comparableSetConst.ALL,
      comparableFilterStructure: {},
      status: {
        comparables: statusConst.LOADING,
        profileForm: statusConst.PENDING,
        toggleStatusList: [],
      },
      numberOfSkips: 1,
      showMore: null,
      displayMapButtons: true,
      automaticSearchOnShapeChange: false,
      selectedSubTab: comparableSubTabConst.MAP,
      // areFiltersAvailable: false,
      infoPopUp: {
        comparable: null,
        comparableId: null,
        isLoading: null,
        isLoaded: null,
        isOpen: null,
        comparableBasket: null,
        isDual: null,
      },
      zone: {
        figureType: 'circle',
        figure: {},
      },
      filters: {},
      sortList: [
        { sortFld: 'ComparableDate', sortDir: 'desc' },
        { sortFld: 'UnitPrice', sortDir: 'asc' },
      ],

      profileMla: null,
    };
  },

  getCommonFiltersToStore() {
    return {
      selectedUse: null,
      selectedSource: [],
      selectedSubTypes: [],
      comparableType: null,
      location: null,
      searchType: 'location',
      freeText: null,
      polygon: null,
      filterByTransactionDateRange: null,
      transactionDateFrom: null,
      transactionDateTo: null,
      transactionDateBefore: null,
      transactionDateSubtraction: null,
      radiusInputValue: null,
      propertyRights: { ValueDesc: 'All', ValueCode: 'All' },
      Reimbursements: [],
      ReimbursementsNotNull: false,
    };
  },

  getCommonResearchAttributesToStore() {
    return {
      // State - campo - research busqueda
      researchComparableSortField: null,
      // State - direccion - research busqueda
      researchComparableSortDirection: 'desc',
      // State - direccion - research busqueda
      researchComparableSortParamId: 0,
      // State - campo - research cesta
      researchBasketSortField: null,
      // State - direccion - research cesta
      researchBasketSortDirection: 'desc',
    };
  },
};
